import { useState, useRef, useEffect } from 'react'
import Image from 'next/image'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ResponsiveDiv from 'components/common/ResponsiveDiv'

const VenderServiceIntro = ({ serviceIntro }) => {
  const [expanded, setExpanded] = useState(false)
  const [isOverflow, setIsOverflow] = useState(false)
  const [mounted, setMounted] = useState(false)
  const textRef = useRef(null)

  useEffect(() => {
    setMounted(true)
  }, [])

  useEffect(() => {
    if (!textRef.current) return
    setIsOverflow(textRef.current.scrollHeight > textRef.current.clientHeight)
  }, [serviceIntro?.description, mounted])

  if (!serviceIntro?.description && !serviceIntro?.image?.url) return null

  return (
    <Box
      mb={18}
      display="flex"
      flexDirection={{ xs: 'column', md: 'row' }}
      alignItems={{ xs: 'flex-start', md: 'center' }}
      justifyContent="space-between"
      gap={{ xs: 5, md: 12 }}
    >
      <Box display="flex" flexDirection="column" gap={6}>
        <ResponsiveDiv>
          <Typography variant="h5">服務介紹</Typography>
        </ResponsiveDiv>
        {!!serviceIntro?.description && (
          <Box display="flex" flexDirection="column" gap={4}>
            <Typography
              ref={textRef}
              variant="paraBodyMedium"
              color="text.minus2"
              sx={
                mounted
                  ? {
                      display: '-webkit-box',
                      WebkitLineClamp: expanded ? 'unset' : 10,
                      WebkitBoxOrient: 'vertical',
                      overflow: 'hidden',
                      whiteSpace: 'pre-wrap',
                      wordBreak: 'break-all',
                    }
                  : { whiteSpace: 'pre-wrap', wordBreak: 'break-all' }
              }
            >
              {serviceIntro.description}
            </Typography>
            {(isOverflow || expanded) && (
              <Box
                display="flex"
                alignItems="center"
                onClick={() => setExpanded((prev) => !prev)}
                width="fit-content"
                mt={2}
                sx={{ cursor: 'pointer' }}
              >
                <Typography variant="paraBodyMedium" color="primary.mainPlus2">
                  {expanded ? '收合' : '查看完整資訊'}
                </Typography>
                {expanded ? (
                  <ExpandLessIcon
                    sx={{ color: 'primary.mainPlus2', fontSize: 20 }}
                  />
                ) : (
                  <ExpandMoreIcon
                    sx={{ color: 'primary.mainPlus2', fontSize: 20 }}
                  />
                )}
              </Box>
            )}
          </Box>
        )}
      </Box>

      {!!serviceIntro?.image?.url && (
        <Box
          flexShrink={0}
          position="relative"
          sx={{
            width: { xs: '100%', md: 'calc(40% - 48px)' },
            aspectRatio: '3/2',
            borderRadius: '24px',
            overflow: 'hidden',
            bgcolor: '#d9d9d9',
          }}
        >
          <Image
            src={serviceIntro.image.url}
            fill
            style={{ objectFit: 'cover' }}
            alt="服務介紹圖片"
          />
        </Box>
      )}
    </Box>
  )
}

export default VenderServiceIntro
